import React from "react";
import Modal from "./Modal";

const TermsOfService = ({ isOpen, onClose }) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Terms of Service">
            <div className="max-w-3xl mx-auto p-6 text-gray-800 text-left">
                {/* <h1 className="text-3xl font-bold mb-4">Terms of Service</h1> */}
                <p className="mb-4">
                    By using our service, you agree to these Terms of Service. If you do not
                    agree, please do not use our platform.
                </p>

                <section className="mb-6">
                    <h2 className="text-xl font-semibold mb-2">1. About SoftEstimate</h2>
                    <p>
                        SoftEstimate is a software estimation platform designed to help businesses and individuals estimate project timelines, costs, and resources efficiently. SoftEstimate is owned, operated, and maintained by SoftTelRG ("Company," "we," "us," or "our").
                        <br></br>
                        SoftTelRG is responsible for the development, management, and security of SoftEstimate but is not liable for user-generated content, third-party integrations, or financial decisions made based on its estimations.
                    </p>
                </section>

                <section className="mb-6">
                    <h2 className="text-xl font-semibold mb-2">
                        2. Eligibility & Account Usage
                    </h2>
                    <ul className="pl-3">
                        <li>✅ You must be at least 18 years old to use SoftEstimate.</li>
                        <li>✅ You are responsible for all activities on your account.</li>
                        <li>✅ You agree not to misuse our service or use it for any illegal activities.
                        </li>
                    </ul>
                </section>

                <section className="mb-6">
                    <h2 className="text-xl font-semibold mb-2">
                        3. Software & Service Dependencies
                    </h2>
                    <p>
                        SoftEstimate is built using React and open-source libraries. Our
                        platform integrates with Stripe, Google, Microsoft, and Firebase for
                        authentication and payments and is hosted on Vercel. Any downtime,
                        limited access, or service interruptions may be due to these
                        third-party services. We are not responsible for their policies,
                        actions, or technical failures.
                    </p>
                </section>

                <section className="mb-6">
                    <h2 className="text-xl font-semibold mb-2">
                        4. No Data Storage & Privacy Protection
                    </h2>
                    <ul className="pl-3">
                        <li>✅ We have a strict policy not to store any user data on our servers.</li>
                        <li>✅ We do not handle, process, or store any sensitive financial information.</li>
                        <li>✅ Your use of third-party services (e.g., Stripe, Google, Microsoft) is subject to their respective privacy policies.
                        </li>
                    </ul>
                </section>

                <section className="mb-6">
                    <h2 className="text-xl font-semibold mb-2">
                        5. Subscription & Payments
                    </h2>
                    <ul className="pl-3">
                        <li>✅ Our subscription and payments are managed via Stripe.</li>
                        <li>✅ No refunds will be provided, but you may cancel anytime to avoid future charges.</li>
                        <li>✅ Pricing is subject to change with prior notice.</li>
                    </ul>
                </section>

                <section className="mb-6">
                    <h2 className="text-xl font-semibold mb-2">6. Limitation of Liability</h2>
                    <p>
                        SoftEstimate provides estimates for reference only. We are not responsible for business losses, incorrect calculations, or financial decisions made based on the estimates generated.
                    </p>
                </section>

                <section className="mb-6">
                    <h2 className="text-xl font-semibold mb-2">
                        7. Contact for Support & Issues
                    </h2>
                    <p>
                        For technical issues or concerns with the estimation engine, contact
                        our team at{" "}
                        <a
                            href="mailto:admin@softestimate.com"
                            className="text-blue-600 underline"
                        >
                            admin@softestimate.com
                        </a>
                        .
                    </p>
                </section>
            </div>
        </Modal>
    );
};

export default TermsOfService;
